import * as React from "react";

const ChevronLeft: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="25" fill="none" viewBox="0 0 14 25">
            <path stroke="#2C2420" strokeWidth="2" d="M12.908 23.815L1.5 12.407 12.908 1"></path>
        </svg>
    );
};

export const chevronLeftString =
    "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwb2x5bGluZSBwb2ludHM9IjE1IDE4IDkgMTIgMTUgNiI+PC9wb2x5bGluZT48L3N2Zz4=";

export default React.memo(ChevronLeft);
